import { config } from 'lib-shared-backend-config';
import { getHighestUserRole } from 'lib-shared-user-role';
/**
 * Olvy (https://olvy.co/) is used in Dixa to collect feedback from our users
 * (support agents) also know as Agent Empowerment Score. The Olvy widget opens
 * and asks for a score and comments. For more info talk to Customer Success.
 */
class OlvyWrapper {
    load(profile, organization) {
        const DELAY = 600000; // 10 min delay before we show the feedback widget;
        (function (w, d, url) {
            var _a;
            const script = d.createElement('script');
            const first = d.getElementsByTagName('script')[0];
            script.async = true;
            script.src = url;
            (_a = first === null || first === void 0 ? void 0 : first.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, first);
            const setAttributeFromEvent = (event) => {
                script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
                if (event.type === 'load' && window.Olvy) {
                    window.OlvyUtils.setUser(config.sdk.olvy, {
                        name: profile.name,
                        email: profile.email,
                        identifier: profile.id,
                        designation: getHighestUserRole(profile.roles),
                        meta: organization,
                    });
                    window.setTimeout(() => {
                        new window.Olvy(config.sdk.olvy);
                    }, DELAY);
                }
                else {
                    console.error('[olvy error]');
                }
            };
            script.addEventListener('load', setAttributeFromEvent);
            script.addEventListener('error', setAttributeFromEvent);
        })(window, document, 'https://app.olvy.co/scriptV2.js');
    }
}
export const olvyService = new OlvyWrapper();
